module.exports = __webpack_public_path__ + "img/icon-vtexlegacy.af219bb0.svg";